import { FC, useMemo } from 'react';
import { Avatar, Box, Stack, Typography } from '@mui/material';

import Rainbow from '@shared/images/rainbow.jpg';


interface Props {
  tributes: Tributes.Tribute[];
  unusedCredits: Tributes.AvailableCredit[];
}

export const DashboardHeader: FC<Props> = (props) => {
  const { tributes, unusedCredits } = props;


  const dashboardPicture = useMemo(() => {
    if (tributes.length > 0) {
      return tributes[0].mainPhoto?.file;
    }
    return null;
  }, [tributes]);

  return (
    <Stack>
      <Stack
        sx={{
          backgroundImage: `url(${Rainbow})`,
          position: 'relative',
          backgroundSize: 'cover',
          backgroundPosition: 'center',
          backgroundRepeat: 'no-repeat',
          py: 2,
          '&:before': {
            content: '""',
            position: 'absolute',
            top: 0,
            left: 0,
            width: '100%',
            height: '100%',
            backgroundColor: 'rgba(200, 200, 200, 0.3)',
            zIndex: 1,
          },
        }}
      >
        <Stack
          maxWidth="lg"
          width="100%"
          px={{ xs: 2, xl: 0 }}
          alignItems="center"
          marginLeft="auto"
          marginRight="auto"
          gap={2.5}
          zIndex={2}
          direction={{ xs: 'column', sm: 'row' }}
        >
          <Avatar
            src={dashboardPicture || ''}
            alt="Dashboard Avatar"
            sx={theme => ({
              width: 140,
              height: 140,
              backgroundColor: theme.palette.background.paper,
              color: theme.palette.background.paper,
              border: `8px solid ${theme.palette.primary.main}`,
            })}

          />
          <Stack>
            <Typography color="white" fontWeight={500} fontSize={50} lineHeight={1.2}>
                My LGCYs
            </Typography>
            <Typography variant="body1" color="white" fontWeight={500} fontSize={16}>
                Manage your LGCY Pet Profiles Here
            </Typography>
          </Stack>
        </Stack>
      </Stack>

      <Stack
        bgcolor="primary.main"
        alignItems="center"
      >
        <Box maxWidth="lg" width="100%" py={1} px={{ xs: 2, xl: 0 }}>
          <Typography variant="body2" color="white" fontWeight={500} fontSize={12}>
            {tributes.length} {tributes.length === 1 ? 'LGCY' : 'LGCYs'} | {unusedCredits.length} {unusedCredits.length === 1 ? 'Credit' : 'Credits'}
          </Typography>
        </Box>
      </Stack>
    </Stack>
  );
};
